import { Component } from '@angular/core';
import { FeedbackPlatformSeasonEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Seasons') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformseason-form',
    templateUrl: './feedbackplatformseason.form.component.html'
})
export class FeedbackPlatformSeasonFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformSeasonEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reviewQuestions', sectionName: 'Review Questions', isExpanded: false },
            { sectionKey: 'nominations', sectionName: 'Nominations', isExpanded: false },
            { sectionKey: 'presentations', sectionName: 'Presentations', isExpanded: false },
            { sectionKey: 'participants', sectionName: 'Participants', isExpanded: false },
            { sectionKey: 'sessions', sectionName: 'Sessions', isExpanded: false },
            { sectionKey: 'committeeSelections', sectionName: 'Committee Selections', isExpanded: false },
            { sectionKey: 'committeeMembers', sectionName: 'Committee Members', isExpanded: false }
        ]);
    }
}

